import { DateTime } from 'luxon';
import * as Zod from 'zod';

export const dateTimeValidator = Zod.custom<DateTime>((val) =>
    DateTime.isDateTime(val)
);
